export default __webpack_public_path__ + "static/media/2ef922800f4ceea2c5f80993c7766c02.gif";